import { ValidatorsProps } from '@ui/src';

export enum PermissionEnum {
  SECTION_DASHBOARD = 'SECTION_DASHBOARD',
  SECTION_ACCOUNTS = 'SECTION_ACCOUNTS',
  SECTION_CUSTOMERS = 'SECTION_CUSTOMERS',
  SECTION_AML_KYC = 'SECTION_AML_KYC',
  SECTION_PSP = 'SECTION_PSP',
  SECTION_TRANSACTIONS = 'SECTION_TRANSACTIONS',
  SECTION_CARDS = 'SECTION_CARDS',
  SECTION_REPORTS = 'SECTION_REPORTS',
  SECTION_FEE_TARIFFS = 'SECTION_FEE_TARIFFS',
  SECTION_EXCHANGE_SETTINGS = 'SECTION_EXCHANGE_SETTINGS',
  SECTION_ADMINISTRATION = 'SECTION_ADMINISTRATION',
  ACCOUNTS_CHART = 'ACCOUNTS_CHART',
  ACCOUNTS_LIST = 'ACCOUNTS_LIST',
  ACCOUNTS_STATEMENTS = 'ACCOUNTS_STATEMENTS',
  ACCOUNTS_CREATE_ACTION = 'ACCOUNTS_CREATE_ACTION',
  ACCOUNTS_STATEMENTS_EXPORT_ACTION = 'ACCOUNTS_STATEMENTS_EXPORT_ACTION',
  ACCOUNTS_CHART_ADD_CATEGORY_ACTION = 'ACCOUNTS_CHART_ADD_CATEGORY_ACTION',
  ACCOUNTS_CHART_EDIT_CATEGORY_ACTION = 'ACCOUNTS_CHART_EDIT_CATEGORY_ACTION',
  ACCOUNTS_CHART_ADD_GROUP_ACTION = 'ACCOUNTS_CHART_ADD_GROUP_ACTION',
  ACCOUNTS_CHART_EDIT_GROUP_ACTION = 'ACCOUNTS_CHART_EDIT_GROUP_ACTION',
  ACCOUNTS_CHART_ADD_PRIMARY_ACTION = 'ACCOUNTS_CHART_ADD_PRIMARY_ACTION',
  ACCOUNTS_CHART_EDIT_PRIMARY_ACTION = 'ACCOUNTS_CHART_EDIT_PRIMARY_ACTION',
  INDIVIDUAL_CUSTOMERS_LIST = 'INDIVIDUAL_CUSTOMERS_LIST',
  CORPORATE_CUSTOMERS_LIST = 'CORPORATE_CUSTOMERS_LIST',
  APPLICATIONS_CUSTOMERS_LIST = 'APPLICATIONS_CUSTOMERS_LIST',
  INDIVIDUAL_CUSTOMERS_CREATE_ACTION = 'INDIVIDUAL_CUSTOMERS_CREATE_ACTION',
  INDIVIDUAL_CUSTOMERS_EDIT_DETAILS_ACTION = 'INDIVIDUAL_CUSTOMERS_EDIT_DETAILS_ACTION',
  INDIVIDUAL_CUSTOMERS_EDIT_RISK_ACTION = 'INDIVIDUAL_CUSTOMERS_EDIT_RISK_ACTION',
  INDIVIDUAL_CUSTOMERS_EDIT_TARIFF_ACTION = 'INDIVIDUAL_CUSTOMERS_EDIT_TARIFF_ACTION',
  INDIVIDUAL_CUSTOMERS_EDIT_TOPUP_ACTION = 'INDIVIDUAL_CUSTOMERS_EDIT_TOPUP_ACTION',
  INDIVIDUAL_CUSTOMERS_CLOSE_ACTION = 'INDIVIDUAL_CUSTOMERS_CLOSE_ACTION',
  INDIVIDUAL_CUSTOMERS_TERMINATE_ACTION = 'INDIVIDUAL_CUSTOMERS_TERMINATE_ACTION',
  INDIVIDUAL_CUSTOMERS_ANONYMISE_ACTION = 'INDIVIDUAL_CUSTOMERS_ANONYMISE_ACTION',
  INDIVIDUAL_CUSTOMERS_UPDATE_STATUS_ACTION = 'INDIVIDUAL_CUSTOMERS_UPDATE_STATUS_ACTION',
  CORPORATE_CUSTOMERS_CREATE_ACTION = 'CORPORATE_CUSTOMERS_CREATE_ACTION',
  CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION = 'CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION',
  CORPORATE_CUSTOMERS_EDIT_RISK_ACTION = 'CORPORATE_CUSTOMERS_EDIT_RISK_ACTION',
  CORPORATE_CUSTOMERS_EDIT_ROLES_ACTION = 'CORPORATE_CUSTOMERS_EDIT_ROLES_ACTION',
  CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION = 'CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION',
  CORPORATE_CUSTOMERS_EDIT_SIGNATURE_RULES_ACTION = 'CORPORATE_CUSTOMERS_EDIT_SIGNATURE_RULES_ACTION',
  CORPORATE_CUSTOMERS_EDIT_TARIFF_ACTION = 'CORPORATE_CUSTOMERS_EDIT_TARIFF_ACTION',
  CORPORATE_CUSTOMERS_EDIT_TOPUP_ACTION = 'CORPORATE_CUSTOMERS_EDIT_TOPUP_ACTION',
  CORPORATE_CUSTOMERS_CLOSE_ACTION = 'CORPORATE_CUSTOMERS_CLOSE_ACTION',
  CORPORATE_CUSTOMERS_TERMINATE_ACTION = 'CORPORATE_CUSTOMERS_TERMINATE_ACTION',
  CORPORATE_CUSTOMERS_ANONYMISE_ACTION = 'CORPORATE_CUSTOMERS_ANONYMISE_ACTION',
  CORPORATE_CUSTOMERS_UPDATE_STATUS_ACTION = 'CORPORATE_CUSTOMERS_UPDATE_STATUS_ACTION',
  APPLICATIONS_CUSTOMERS_ACCEPT_ACTION = 'APPLICATIONS_CUSTOMERS_ACCEPT_ACTION',
  APPLICATIONS_CUSTOMERS_EDIT_ACTION = 'APPLICATIONS_CUSTOMERS_EDIT_ACTION',
  APPLICATIONS_CUSTOMERS_CREATE_ACTION = 'APPLICATIONS_CUSTOMERS_CREATE_ACTION',
  MESSAGES_LIST = 'MESSAGES_LIST',
  MESSAGES_ASSIGN_CHAT_TO_ME_ACTION = 'MESSAGES_ASSIGN_CHAT_TO_ME_ACTION',
  MESSAGES_ASSIGN_CHAT_TO_ANOTHER_ACTION = 'MESSAGES_ASSIGN_CHAT_TO_ANOTHER_ACTION',
  BLACKLISTS_LIST = 'BLACKLISTS_LIST',
  BLACKLISTS_ADD_ACTION = 'BLACKLISTS_ADD_ACTION',
  BLACKLISTS_EDIT_ACTION = 'BLACKLISTS_EDIT_ACTION',
  BLACKLISTS_DELETE_ACTION = 'BLACKLISTS_DELETE_ACTION',
  AML_SETTINGS_LIST = 'AML_SETTINGS_LIST',
  AML_GEO_LIST = 'AML_GEO_LIST',
  AML_TX_VOLUME_LIST = 'AML_TX_VOLUME_LIST',
  AML_PRODUCT_LIST = 'AML_PRODUCT_LIST',
  AML_MONITORING_RULES_LIST = 'AML_MONITORING_RULES_LIST',
  AML_SETTINGS_CATEGORY_ADD_ACTION = 'AML_SETTINGS_CATEGORY_ADD_ACTION',
  AML_SETTINGS_CATEGORY_EDIT_ACTION = 'AML_SETTINGS_CATEGORY_EDIT_ACTION',
  AML_SETTINGS_CATEGORY_DELETE_ACTION = 'AML_SETTINGS_CATEGORY_DELETE_ACTION',
  AML_GEO_EDIT_SETTINGS_ACTION = 'AML_GEO_EDIT_SETTINGS_ACTION',
  AML_GEO_EDIT_RS_ACTION = 'AML_GEO_EDIT_RS_ACTION',
  AML_TX_VOLUNE_EDIT_SETTINGS_ACTION = 'AML_TX_VOLUNE_EDIT_SETTINGS_ACTION',
  AML_TX_VOLUME_EDIT_RS_ACTION = 'AML_TX_VOLUME_EDIT_RS_ACTION',
  AML_PRODUCT_EDIT_SETTINGS_ACTION = 'AML_PRODUCT_EDIT_SETTINGS_ACTION',
  AML_PRODUCT_EDIT_RS_ACTION = 'AML_PRODUCT_EDIT_RS_ACTION',
  AML_MONITORING_RULES_ADD_ACTION = 'AML_MONITORING_RULES_ADD_ACTION',
  AML_MONITORING_RULES_EDIT_ACTION = 'AML_MONITORING_RULES_EDIT_ACTION',
  AML_MONITORING_RULES_DELETE_ACTION = 'AML_MONITORING_RULES_DELETE_ACTION',
  PSP_LIST = 'PSP_LIST',
  PSP_ADD_ACTION = 'PSP_ADD_ACTION',
  PSP_EDIT_ACTION = 'PSP_EDIT_ACTION',
  PSP_DELETE_ACTION = 'PSP_DELETE_ACTION',
  PSP_ACCOUNT_ADD_ACTION = 'PSP_ACCOUNT_ADD_ACTION',
  PSP_ACCOUNT_EDIT_ACTION = 'PSP_ACCOUNT_EDIT_ACTION',
  PSP_ACCOUNT_DELETE_ACTION = 'PSP_ACCOUNT_DELETE_ACTION',
  TRANSACTIONS_IMPORT_LIST = 'TRANSACTIONS_IMPORT_LIST',
  TRANSACTIONS_EXPORT_LIST = 'TRANSACTIONS_EXPORT_LIST',
  TRANSACTIONS_INCOMING_LIST = 'TRANSACTIONS_INCOMING_LIST',
  TRANSACTIONS_OUTGOING_LIST = 'TRANSACTIONS_OUTGOING_LIST',
  TRANSACTIONS_INTERNAL_LIST = 'TRANSACTIONS_INTERNAL_LIST',
  TRANSACTIONS_EXCHANGE_LIST = 'TRANSACTIONS_EXCHANGE_LIST',
  TRANSACTIONS_GENERAL_LEDGER_LIST = 'TRANSACTIONS_GENERAL_LEDGER_LIST',
  TRANSACTIONS_NOSTRO_LIST = 'TRANSACTIONS_NOSTRO_LIST',
  TRANSACTIONS_INCOMING_CREATE_ACTION = 'TRANSACTIONS_INCOMING_CREATE_ACTION',
  TRANSACTIONS_INCOMING_EDIT_ACTION = 'TRANSACTIONS_INCOMING_EDIT_ACTION',
  TRANSACTIONS_INCOMING_REVERSE_ACTION = 'TRANSACTIONS_INCOMING_REVERSE_ACTION',
  TRANSACTIONS_INCOMING_CANCEL_ACTION = 'TRANSACTIONS_INCOMING_CANCEL_ACTION',
  TRANSACTIONS_INCOMING_REVIEW_ACTION = 'TRANSACTIONS_INCOMING_REVIEW_ACTION',
  TRANSACTIONS_INCOMING_REQUEST_INFO_ACTION = 'TRANSACTIONS_INCOMING_REQUEST_INFO_ACTION',
  TRANSACTIONS_INCOMING_SEND_TO_AML_ACTION = 'TRANSACTIONS_INCOMING_SEND_TO_AML_ACTION',
  TRANSACTIONS_INCOMING_AML_APPROVE_ACTION = 'TRANSACTIONS_INCOMING_AML_APPROVE_ACTION',
  TRANSACTIONS_INCOMING_AML_REJECT_ACTION = 'TRANSACTIONS_INCOMING_AML_REJECT_ACTION',
  TRANSACTIONS_INCOMING_ACCEPT_FILE_ACTION = 'TRANSACTIONS_INCOMING_ACCEPT_FILE_ACTION',
  TRANSACTIONS_INCOMING_ACCEPT_API_ACTION = 'TRANSACTIONS_INCOMING_ACCEPT_API_ACTION',
  TRANSACTIONS_EXPORT_CREATE_ACTION = 'TRANSACTIONS_EXPORT_CREATE_ACTION',
  TRANSACTIONS_OUTGOING_CREATE_ACTION = 'TRANSACTIONS_OUTGOING_CREATE_ACTION',
  TRANSACTIONS_OUTGOING_PROCESS_CREATED_BY_EMPLOYEE_ACTION = 'TRANSACTIONS_OUTGOING_PROCESS_CREATED_BY_EMPLOYEE_ACTION',
  TRANSACTIONS_OUTGOING_PROCESS_CREATED_BY_CUSTOMER_ACTION = 'TRANSACTIONS_OUTGOING_PROCESS_CREATED_BY_CUSTOMER_ACTION',
  TRANSACTIONS_OUTGOING_CHOOSE_PSP_ACTION = 'TRANSACTIONS_OUTGOING_CHOOSE_PSP_ACTION',
  TRANSACTIONS_OUTGOING_EDIT_ACTION = 'TRANSACTIONS_OUTGOING_EDIT_ACTION',
  TRANSACTIONS_OUTGOING_REVERSE_ACTION = 'TRANSACTIONS_OUTGOING_REVERSE_ACTION',
  TRANSACTIONS_OUTGOING_CANCEL_ACTION = 'TRANSACTIONS_OUTGOING_CANCEL_ACTION',
  TRANSACTIONS_OUTGOING_REVIEW_ACTION = 'TRANSACTIONS_OUTGOING_REVIEW_ACTION',
  TRANSACTIONS_OUTGOING_REQUEST_INFO_ACTION = 'TRANSACTIONS_OUTGOING_REQUEST_INFO_ACTION',
  TRANSACTIONS_OUTGOING_SEND_TO_AML_ACTION = 'TRANSACTIONS_OUTGOING_SEND_TO_AML_ACTION',
  TRANSACTIONS_OUTGOING_AML_APPROVE_ACTION = 'TRANSACTIONS_OUTGOING_AML_APPROVE_ACTION',
  TRANSACTIONS_OUTGOING_AML_REJECT_ACTION = 'TRANSACTIONS_OUTGOING_AML_REJECT_ACTION',
  TRANSACTIONS_OUTGOING_ACCEPT_FILE_ACTION = 'TRANSACTIONS_OUTGOING_ACCEPT_FILE_ACTION',
  TRANSACTIONS_OUTGOING_ACCEPT_API_ACTION = 'TRANSACTIONS_OUTGOING_ACCEPT_API_ACTION',
  TRANSACTIONS_EXCHANGE_CREATE_ACTION = 'TRANSACTIONS_EXCHANGE_CREATE_ACTION',
  TRANSACTIONS_EXCHANGE_PROCESS_CREATED_BY_EMPLOYEE_ACTION = 'TRANSACTIONS_EXCHANGE_PROCESS_CREATED_BY_EMPLOYEE_ACTION',
  TRANSACTIONS_EXCHANGE_PROCESS_CREATED_BY_CUSTOMER_ACTION = 'TRANSACTIONS_EXCHANGE_PROCESS_CREATED_BY_CUSTOMER_ACTION',
  TRANSACTIONS_EXCHANGE_CHOOSE_PSP_ACTION = 'TRANSACTIONS_EXCHANGE_CHOOSE_PSP_ACTION',
  TRANSACTIONS_EXCHANGE_EDIT_ACTION = 'TRANSACTIONS_EXCHANGE_EDIT_ACTION',
  TRANSACTIONS_EXCHANGE_REVERSE_ACTION = 'TRANSACTIONS_EXCHANGE_REVERSE_ACTION',
  TRANSACTIONS_EXCHANGE_CANCEL_ACTION = 'TRANSACTIONS_EXCHANGE_CANCEL_ACTION',
  TRANSACTIONS_EXCHANGE_REVIEW_ACTION = 'TRANSACTIONS_EXCHANGE_REVIEW_ACTION',
  TRANSACTIONS_EXCHANGE_REQUEST_INFO_ACTION = 'TRANSACTIONS_EXCHANGE_REQUEST_INFO_ACTION',
  TRANSACTIONS_EXCHANGE_SEND_TO_AML_ACTION = 'TRANSACTIONS_EXCHANGE_SEND_TO_AML_ACTION',
  TRANSACTIONS_EXCHANGE_AML_APPROVE_ACTION = 'TRANSACTIONS_EXCHANGE_AML_APPROVE_ACTION',
  TRANSACTIONS_EXCHANGE_AML_REJECT_ACTION = 'TRANSACTIONS_EXCHANGE_AML_REJECT_ACTION',
  TRANSACTIONS_EXCHANGE_ACCEPT_FILE_ACTION = 'TRANSACTIONS_EXCHANGE_ACCEPT_FILE_ACTION',
  TRANSACTIONS_EXCHANGE_ACCEPT_API_ACTION = 'TRANSACTIONS_EXCHANGE_ACCEPT_API_ACTION',
  TRANSACTIONS_GENERAL_LEDGER_CREATE_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_CREATE_ACTION',
  TRANSACTIONS_GENERAL_LEDGER_EDIT_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_EDIT_ACTION',
  TRANSACTIONS_GENERAL_LEDGER_REVERSE_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_REVERSE_ACTION',
  TRANSACTIONS_NOSTRO_CREATE_ACTION = 'TRANSACTIONS_NOSTRO_CREATE_ACTION',
  TRANSACTIONS_NOSTRO_EDIT_ACTION = 'TRANSACTIONS_NOSTRO_EDIT_ACTION',
  TRANSACTIONS_NOSTRO_REVERSE_ACTION = 'TRANSACTIONS_NOSTRO_REVERSE_ACTION',
  TRANSACTIONS_INTERNAL_CREATE_ACTION = 'TRANSACTIONS_INTERNAL_CREATE_ACTION',
  TRANSACTIONS_INTERNAL_EDIT_ACTION = 'TRANSACTIONS_INTERNAL_EDIT_ACTION',
  CARDS_LIST = 'CARDS_LIST',
  CARDS_OCT_LIST = 'CARDS_OCT_LIST',
  CARDS_ACCEPT_ACTION = 'CARDS_ACCEPT_ACTION',
  CARDS_ACTIVATE_ACTION = 'CARDS_ACTIVATE_ACTION',
  CARDS_FREEZE_ACTION = 'CARDS_FREEZE_ACTION',
  CARDS_UNFREEZE_ACTION = 'CARDS_UNFREEZE_ACTION',
  CARDS_CANCEL_ACTION = 'CARDS_CANCEL_ACTION',
  CARDS_OCT_PROCESS_ACTION = 'CARDS_OCT_PROCESS_ACTION',
  CARDS_OCT_CHOOSE_PSP_ACTION = 'CARDS_OCT_CHOOSE_PSP_ACTION',
  CARDS_OCT_REVERSE_ACTION = 'CARDS_OCT_REVERSE_ACTION',
  CARDS_OCT_CANCEL_ACTION = 'CARDS_OCT_CANCEL_ACTION',
  CARDS_OCT_REVIEW_AND_APPROVE_ACTION = 'CARDS_OCT_REVIEW_AND_APPROVE_ACTION',
  CARDS_OCT_REQUEST_INFO_ACTION = 'CARDS_OCT_REQUEST_INFO_ACTION',
  CARDS_OCT_REQUEST_SEND_TO_AML_ACTION = 'CARDS_OCT_REQUEST_SEND_TO_AML_ACTION',
  CARDS_OCT_REQUEST_AML_APPROVE_ACTION = 'CARDS_OCT_REQUEST_AML_APPROVE_ACTION',
  CARDS_OCT_REQUEST_AML_REJECT_ACTION = 'CARDS_OCT_REQUEST_AML_REJECT_ACTION',
  REPORTS_BALANCE_SHEET_LIST = 'REPORTS_BALANCE_SHEET_LIST',
  REPORTS_PROFIT_LOSS_LIST = 'REPORTS_PROFIT_LOSS_LIST',
  REPORTS_SAFEGUARDING_LIST = 'REPORTS_SAFEGUARDING_LIST',
  REPORTS_CAPITAL_ADEQUACY_LIST = 'REPORTS_CAPITAL_ADEQUACY_LIST',
  REPORTS_PSP_LIST = 'REPORTS_PSP_LIST',
  REPORTS_CURRENCY_POSITION_LIST = 'REPORTS_CURRENCY_POSITION_LIST',
  REPORTS_BALANCE_SHEET_EXPORT_ACTION = 'REPORTS_BALANCE_SHEET_EXPORT_ACTION',
  REPORTS_PROFIT_LOSS_EXPORT_ACTION = 'REPORTS_PROFIT_LOSS_EXPORT_ACTION',
  REPORTS_SAFEGUARDING_EXPORT_ACTION = 'REPORTS_SAFEGUARDING_EXPORT_ACTION',
  REPORTS_CAPITAL_ADEQUACY_EXPORT_ACTION = 'REPORTS_CAPITAL_ADEQUACY_EXPORT_ACTION',
  REPORTS_PSP_EXPORT_ACTION = 'REPORTS_PSP_EXPORT_ACTION',
  REPORTS_CURRENCY_POSITION_EXPORT_ACTION = 'REPORTS_CURRENCY_POSITION_EXPORT_ACTION',
  FEES_LIST = 'FEES_LIST',
  FEES_TYPES_LIST = 'FEES_TYPES_LIST',
  TARIFFS_LIST = 'TARIFFS_LIST',
  FEES_CREATE_ACTION = 'FEES_CREATE_ACTION',
  FEES_EDIT_ACTION = 'FEES_EDIT_ACTION',
  FEES_TYPES_CREATE_ACTION = 'FEES_TYPES_CREATE_ACTION',
  FEES_TYPES_EDIT_ACTION = 'FEES_TYPES_EDIT_ACTION',
  TARIFFS_CREATE_ACTION = 'TARIFFS_CREATE_ACTION',
  TARIFFS_EDIT_ACTION = 'TARIFFS_EDIT_ACTION',
  SETTINGS_CURRENCIES_LIST = 'SETTINGS_CURRENCIES_LIST',
  SETTINGS_EXCHANGE_RATES_LIST = 'SETTINGS_EXCHANGE_RATES_LIST',
  SETTINGS_EXCHANGE_MARGINS_LIST = 'SETTINGS_EXCHANGE_MARGINS_LIST',
  SETTINGS_PRODUCTS_LIST = 'SETTINGS_PRODUCTS_LIST',
  SETTINGS_CLIENT_ACTIVITIES_LIST = 'SETTINGS_CLIENT_ACTIVITIES_LIST',
  SETTINGS_DELIVERY_CHANNELS_LIST = 'SETTINGS_DELIVERY_CHANNELS_LIST',
  SETTINGS_SOURCES_OF_FUNDS_LIST = 'SETTINGS_SOURCES_OF_FUNDS_LIST',
  SETTINGS_SYSTEM_LIST = 'SETTINGS_SYSTEM_LIST',
  SETTINGS_CURRENCIES_CREATE_ACTION = 'SETTINGS_CURRENCIES_CREATE_ACTION',
  SETTINGS_CURRENCIES_EDIT_ACTION = 'SETTINGS_CURRENCIES_EDIT_ACTION',
  SETTINGS_EXCHANGE_EDIT_PAIRS_ACTION = 'SETTINGS_EXCHANGE_EDIT_PAIRS_ACTION',
  SETTINGS_EXCHANGE_EDIT_MARGINS_ACTION = 'SETTINGS_EXCHANGE_EDIT_MARGINS_ACTION',
  SETTINGS_PRODUCTS_CREATE_ACTION = 'SETTINGS_PRODUCTS_CREATE_ACTION',
  SETTINGS_PRODUCTS_EDIT_ACTION = 'SETTINGS_PRODUCTS_EDIT_ACTION',
  SETTINGS_PRODUCTS_DELETE_ACTION = 'SETTINGS_PRODUCTS_DELETE_ACTION',
  SETTINGS_CLIENT_ACTIVITIES_CREATE_ACTION = 'SETTINGS_CLIENT_ACTIVITIES_CREATE_ACTION',
  SETTINGS_CLIENT_ACTIVITIES_EDIT_ACTION = 'SETTINGS_CLIENT_ACTIVITIES_EDIT_ACTION',
  SETTINGS_CLIENT_ACTIVITIES_DELETE_ACTION = 'SETTINGS_CLIENT_ACTIVITIES_DELETE_ACTION',
  SETTINGS_DELIVERY_CHANNELS_CREATE_ACTION = 'SETTINGS_DELIVERY_CHANNELS_CREATE_ACTION',
  SETTINGS_DELIVERY_CHANNELS_EDIT_ACTION = 'SETTINGS_DELIVERY_CHANNELS_EDIT_ACTION',
  SETTINGS_DELIVERY_CHANNELS_DELETE_ACTION = 'SETTINGS_DELIVERY_CHANNELS_DELETE_ACTION',
  SETTINGS_SOURCES_OF_FUNDS_CREATE_ACTION = 'SETTINGS_SOURCES_OF_FUNDS_CREATE_ACTION',
  SETTINGS_SOURCES_OF_FUNDS_EDIT_ACTION = 'SETTINGS_SOURCES_OF_FUNDS_EDIT_ACTION',
  SETTINGS_SOURCES_OF_FUNDS_DELETE_ACTION = 'SETTINGS_SOURCES_OF_FUNDS_DELETE_ACTION',
  SETTINGS_SYSTEM_CREATE_ACTION = 'SETTINGS_SYSTEM_CREATE_ACTION',
  SETTINGS_SYSTEM_EDIT_ACTION = 'SETTINGS_SYSTEM_EDIT_ACTION',
  SETTINGS_RISK_SCORE_RANGES_LIST = 'SETTINGS_RISK_SCORE_RANGES_LIST',
  SETTINGS_RISK_SCORE_RANGES_CREATE_ACTION = 'SETTINGS_RISK_SCORE_RANGES_CREATE_ACTION',
  SETTINGS_RISK_SCORE_RANGES_EDIT_ACTION = 'SETTINGS_RISK_SCORE_RANGES_EDIT_ACTION',
  SETTINGS_RISK_SCORE_RANGES_DELETE_ACTION = 'SETTINGS_RISK_SCORE_RANGES_DELETE_ACTION',
  USERS_LIST = 'USERS_LIST',
  USERS_ROLES_LIST = 'USERS_ROLES_LIST',
  USERS_CREATE_ACTION = 'USERS_CREATE_ACTION',
  USERS_EDIT_ACTION = 'USERS_EDIT_ACTION',
  USERS_ARCHIVE_ACTION = 'USERS_ARCHIVE_ACTION',
  USERS_ROLES_CREATE_ACTION = 'USERS_ROLES_CREATE_ACTION',
  USERS_ROLES_EDIT_ACTION = 'USERS_ROLES_EDIT_ACTION',
  USERS_ROLES_ARCHIVE_ACTION = 'USERS_ROLES_ARCHIVE_ACTION',
  SETTINGS_FACTORS_LIST = 'SETTINGS_FACTORS_LIST',
  SETTINGS_FACTORS_ACTION = 'SETTINGS_FACTORS_ACTION',
  SETTINGS_INCORPORATION_DATES_LIST = 'SETTINGS_INCORPORATION_DATES_LIST',
  SETTINGS_INCORPORATION_DATES_CREATE_ACTION = 'SETTINGS_INCORPORATION_DATES_CREATE_ACTION',
  SETTINGS_INCORPORATION_DATES_EDIT_ACTION = 'SETTINGS_INCORPORATION_DATES_EDIT_ACTION',
  SETTINGS_INCORPORATION_DATES_DELETE_ACTION = 'SETTINGS_INCORPORATION_DATES_DELETE_ACTION',
  TRANSACTIONS_INTERNAL_AML_LIST = 'TRANSACTIONS_INTERNAL_AML_LIST',
  TRANSACTIONS_INTERNAL_AML_APPROVE_ACTION = 'TRANSACTIONS_INTERNAL_AML_APPROVE_ACTION',
  TRANSACTIONS_INTERNAL_AML_REJECT_ACTION = 'TRANSACTIONS_INTERNAL_AML_REJECT_ACTION',
  TRANSACTIONS_INCOMING_AML_LIST = 'TRANSACTIONS_INCOMING_AML_LIST',
  TRANSACTIONS_OUTGOING_AML_LIST = 'TRANSACTIONS_OUTGOING_AML_LIST',
  TRANSACTIONS_GENERAL_LEDGER_DELETE_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_DELETE_ACTION',
  SETTINGS_TRANSACTIONS_VOLUMES_LIST = 'SETTINGS_TRANSACTIONS_VOLUMES_LIST',
  SETTINGS_TRANSACTIONS_VOLUMES_CREATE_ACTION = 'SETTINGS_TRANSACTIONS_VOLUMES_CREATE_ACTION',
  SETTINGS_TRANSACTIONS_VOLUMES_EDIT_ACTION = 'SETTINGS_TRANSACTIONS_VOLUMES_EDIT_ACTION',
  SETTINGS_TRANSACTIONS_VOLUMES_DELETE_ACTION = 'SETTINGS_TRANSACTIONS_VOLUMES_DELETE_ACTION',
  SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_LIST = 'SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_LIST',
  SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_CREATE_ACTION = 'SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_CREATE_ACTION',
  SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_UPDATE_ACTION = 'SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_UPDATE_ACTION',
  SETTINGS_SIC_CODES_LIST = 'SETTINGS_SIC_CODES_LIST',
  CORPORATE_CUSTOMERS_DOCUMENTS_LIST = 'CORPORATE_CUSTOMERS_DOCUMENTS_LIST',
  CORPORATE_CUSTOMERS_DOCUMENTS_CREATE_ACTION = 'CORPORATE_CUSTOMERS_DOCUMENTS_CREATE_ACTION',
  CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION = 'CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION',
  CORPORATE_CUSTOMERS_DOCUMENTS_DELETE_ACTION = 'CORPORATE_CUSTOMERS_DOCUMENTS_DELETE_ACTION',
  INDIVIDUAL_CUSTOMERS_DOCUMENTS_LIST = 'INDIVIDUAL_CUSTOMERS_DOCUMENTS_LIST',
  INDIVIDUAL_CUSTOMERS_DOCUMENTS_CREATE_ACTION = 'INDIVIDUAL_CUSTOMERS_DOCUMENTS_CREATE_ACTION',
  INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION = 'INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION',
  INDIVIDUAL_CUSTOMERS_DOCUMENTS_DELETE_ACTION = 'INDIVIDUAL_CUSTOMERS_DOCUMENTS_DELETE_ACTION',
  APPLICATIONS_CUSTOMERS_DOCUMENTS_LIST = 'APPLICATIONS_CUSTOMERS_DOCUMENTS_LIST',
  APPLICATIONS_CUSTOMERS_DOCUMENTS_CREATE_ACTION = 'APPLICATIONS_CUSTOMERS_DOCUMENTS_CREATE_ACTION',
  APPLICATIONS_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION = 'APPLICATIONS_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION',
  APPLICATIONS_CUSTOMERS_DOCUMENTS_DELETE_ACTION = 'APPLICATIONS_CUSTOMERS_DOCUMENTS_DELETE_ACTION',
  PSP_ACCOUNT_DOCUMENTS_LIST = 'PSP_ACCOUNT_DOCUMENTS_LIST',
  PSP_ACCOUNT_DOCUMENTS_CREATE_ACTION = 'PSP_ACCOUNT_DOCUMENTS_CREATE_ACTION',
  PSP_ACCOUNT_DOCUMENTS_DELETE_ACTION = 'PSP_ACCOUNT_DOCUMENTS_DELETE_ACTION',
  PSP_DOCUMENTS_LIST = 'PSP_DOCUMENTS_LIST',
  PSP_DOCUMENTS_CREATE_ACTION = 'PSP_DOCUMENTS_CREATE_ACTION',
  PSP_DOCUMENTS_DELETE_ACTION = 'PSP_DOCUMENTS_DELETE_ACTION',
  TRANSACTIONS_INCOMING_AML_DOCUMENTS_LIST = 'TRANSACTIONS_INCOMING_AML_DOCUMENTS_LIST',
  TRANSACTIONS_OUTGOING_AML_DOCUMENTS_LIST = 'TRANSACTIONS_OUTGOING_AML_DOCUMENTS_LIST',
  TRANSACTIONS_INTERNAL_AML_DOCUMENTS_LIST = 'TRANSACTIONS_INTERNAL_AML_DOCUMENTS_LIST',
  TRANSACTIONS_INTERNAL_AML_DOCUMENT_CREATE_ACTION = 'TRANSACTIONS_INTERNAL_AML_DOCUMENT_CREATE_ACTION',
  TRANSACTIONS_INTERNAL_AML_DOCUMENT_DELETE_ACTION = 'TRANSACTIONS_INTERNAL_AML_DOCUMENT_DELETE_ACTION',
  TRANSACTIONS_INCOMING_AML_DOCUMENT_CREATE_ACTION = 'TRANSACTIONS_INCOMING_AML_DOCUMENT_CREATE_ACTION',
  TRANSACTIONS_INCOMING_AML_DOCUMENT_DELETE_ACTION = 'TRANSACTIONS_INCOMING_AML_DOCUMENT_DELETE_ACTION',
  TRANSACTIONS_OUTGOING_AML_DOCUMENT_CREATE_ACTION = 'TRANSACTIONS_OUTGOING_AML_DOCUMENT_CREATE_ACTION',
  TRANSACTIONS_OUTGOING_AML_DOCUMENT_DELETE_ACTION = 'TRANSACTIONS_OUTGOING_AML_DOCUMENT_DELETE_ACTION',
  CUSTOMERS_STATEMENTS_LIST = 'CUSTOMERS_STATEMENTS_LIST',
  DOCUMENTS_LIST = 'DOCUMENTS_LIST',
  DOCUMENTS_CREATE_ACTION = 'DOCUMENTS_CREATE_ACTION',
  DOCUMENTS_UPDATE_ACTION = 'DOCUMENTS_UPDATE_ACTION',
  DOCUMENTS_COMMENTS_ACTION = 'DOCUMENTS_COMMENTS_ACTION',
  ACCOUNTS_CLOSE_ALL_ACTION = 'ACCOUNTS_CLOSE_ALL_ACTION',
  ACCOUNTS_CLOSE_CUSTOMERS_ACTION = 'ACCOUNTS_CLOSE_CUSTOMERS_ACTION',
  INDIVIDUAL_CUSTOMERS_TRANSACTIONS_WITH_WARNINGS_LIST = 'INDIVIDUAL_CUSTOMERS_TRANSACTIONS_WITH_WARNINGS_LIST',
  CORPORATE_CUSTOMERS_TRANSACTIONS_WITH_WARNINGS_LIST = 'CORPORATE_CUSTOMERS_TRANSACTIONS_WITH_WARNINGS_LIST',
  AGREEMENTS_LIST = 'AGREEMENTS_LIST',
  AGREEMENTS_CREATE_ACTION = 'AGREEMENTS_CREATE_ACTION',
  AGREEMENTS_ARCHIVE_ACTION = 'AGREEMENTS_ARCHIVE_ACTION',
  TRANSACTIONS_DOCUMENTS_LIST = 'TRANSACTIONS_DOCUMENTS_LIST',
  TRANSACTIONS_DOCUMENTS_CREATE_ACTION = 'TRANSACTIONS_DOCUMENTS_CREATE_ACTION',
  TRANSACTIONS_DOCUMENTS_DELETE_ACTION = 'TRANSACTIONS_DOCUMENTS_DELETE_ACTION',
  TRANSACTIONS_DOCUMENTS_EDIT_ACTION = 'TRANSACTIONS_DOCUMENTS_EDIT_ACTION',
  CHANNELS_LIST = 'CHANNELS_LIST',
  CHANNELS_CREATE_ACTION = 'CHANNELS_CREATE_ACTION',
  CHANNELS_UPDATE_ACTION = 'CHANNELS_UPDATE_ACTION',
  USERS_EDIT_STATUS_ACTION = 'USERS_EDIT_STATUS_ACTION',
  INDIVIDUAL_CUSTOMERS_AML_LIST = 'INDIVIDUAL_CUSTOMERS_AML_LIST',
  CORPORATE_CUSTOMERS_AML_LIST = 'CORPORATE_CUSTOMERS_AML_LIST',
  APPLICATIONS_CUSTOMERS_AML_LIST = 'APPLICATIONS_CUSTOMERS_AML_LIST',
  INDIVIDUAL_CUSTOMERS_AML_APPROVE_ACTION = 'INDIVIDUAL_CUSTOMERS_AML_APPROVE_ACTION',
  INDIVIDUAL_CUSTOMERS_AML_REJECT_ACTION = 'INDIVIDUAL_CUSTOMERS_AML_REJECT_ACTION',
  CORPORATE_CUSTOMERS_AML_APPROVE_ACTION = 'CORPORATE_CUSTOMERS_AML_APPROVE_ACTION',
  CORPORATE_CUSTOMERS_AML_REJECT_ACTION = 'CORPORATE_CUSTOMERS_AML_REJECT_ACTION',
  APPLICATIONS_CUSTOMERS_AML_APPROVE_ACTION = 'APPLICATIONS_CUSTOMERS_AML_APPROVE_ACTION',
  APPLICATIONS_CUSTOMERS_AML_REJECT_ACTION = 'APPLICATIONS_CUSTOMERS_AML_REJECT_ACTION',
  COFF_CUSTOMERS_CONVERT_TO_INDIVIDUAL_ACTION = 'COFF_CUSTOMERS_CONVERT_TO_INDIVIDUAL_ACTION',
  CORPORATE_CUSTOMERS_AML_EXPORT_ACTION = 'CORPORATE_CUSTOMERS_AML_EXPORT_ACTION',
  INDIVIDUAL_CUSTOMERS_AML_EXPORT_ACTION = 'INDIVIDUAL_CUSTOMERS_AML_EXPORT_ACTION',
  SECTION_BENEFICIARIES = 'SECTION_BENEFICIARIES',
  BENEFICIARIES_LIST = 'BENEFICIARIES_LIST',
  BENEFICIARIES_CREATE_ACTION = 'BENEFICIARIES_CREATE_ACTION',
  BENEFICIARIES_UPDATE_ACTION = 'BENEFICIARIES_UPDATE_ACTION',
  BENEFICIARIES_EDIT_STATUS_ACTION = 'BENEFICIARIES_EDIT_STATUS_ACTION',
  BENEFICIARIES_DELETE_ACTION = 'BENEFICIARIES_DELETE_ACTION',
  APPLICATIONS_SCHEMES_LIST = 'APPLICATIONS_SCHEMES_LIST',
  APPLICATIONS_SCHEMES_CREATE_ACTION = 'APPLICATIONS_SCHEMES_CREATE_ACTION',
  APPLICATIONS_SCHEMES_EDIT_ACTION = 'APPLICATIONS_SCHEMES_EDIT_ACTION',
  APPLICATIONS_CUSTOMERS_SUBMIT_ACTION = 'APPLICATIONS_CUSTOMERS_SUBMIT_ACTION',
  PSP_INTEGRATION_ACCOUNT_LIST = 'PSP_INTEGRATION_ACCOUNT_LIST',
  PSP_INTEGRATION_ACCOUNT_ADD_ACTION = 'PSP_INTEGRATION_ACCOUNT_ADD_ACTION',
  PSP_INTEGRATION_ACCOUNT_EDIT_ACTION = 'PSP_INTEGRATION_ACCOUNT_EDIT_ACTION',
  AUDIT_LOG_LIST = 'AUDIT_LOG_LIST',
  INDIVIDUAL_CUSTOMERS_DOCUMENTS_EDIT_ACTION = 'INDIVIDUAL_CUSTOMERS_DOCUMENTS_EDIT_ACTION',
  CORPORATE_CUSTOMERS_DOCUMENTS_EDIT_ACTION = 'CORPORATE_CUSTOMERS_DOCUMENTS_EDIT_ACTION',
  APPLICATIONS_CUSTOMERS_DOCUMENTS_EDIT_ACTION = 'APPLICATIONS_CUSTOMERS_DOCUMENTS_EDIT_ACTION',
  PSP_DOCUMENTS_EDIT_ACTION = 'PSP_DOCUMENTS_EDIT_ACTION',
  SETTINGS_AUTO_EXCHANGE_LIST = 'SETTINGS_AUTO_EXCHANGE_LIST',
  SETTINGS_AUTO_EXCHANGE_CREATE_ACTION = 'SETTINGS_AUTO_EXCHANGE_CREATE_ACTION',
  SETTINGS_AUTO_EXCHANGE_UPDATE_ACTION = 'SETTINGS_AUTO_EXCHANGE_UPDATE_ACTION',
  PSP_ACCOUNT_DOCUMENTS_EDIT_ACTION = 'PSP_ACCOUNT_DOCUMENTS_EDIT_ACTION',
  SETTINGS_CUSTOM_RATE_EXCHANGE_LIST = 'SETTINGS_CUSTOM_RATE_EXCHANGE_LIST',
  SETTINGS_CUSTOM_RATE_EXCHANGE_CREATE_ACTION = 'SETTINGS_CUSTOM_RATE_EXCHANGE_CREATE_ACTION',
  SETTINGS_CUSTOM_RATE_EXCHANGE_UPDATE_ACTION = 'SETTINGS_CUSTOM_RATE_EXCHANGE_UPDATE_ACTION',
  NOTIFICATIONS_TYPES_TEMPLATE_LIST = 'NOTIFICATIONS_TYPES_TEMPLATE_LIST',
  NOTIFICATIONS_TYPES_TEMPLATE_EDIT_ACTION = 'NOTIFICATIONS_TYPES_TEMPLATE_EDIT_ACTION',
  NOTIFICATIONS_TYPES_TEMPLATE_CREATE_ACTION = 'NOTIFICATIONS_TYPES_TEMPLATE_CREATE_ACTION',
  USERS_EDIT_NOTIFICATIONS_TYPES_TEMPLATE_ACTION = 'USERS_EDIT_NOTIFICATIONS_TYPES_TEMPLATE_ACTION',
  USERS_EDIT_NOTIFICATIONS_TYPES_ACTION = 'USERS_EDIT_NOTIFICATIONS_TYPES_ACTION',
  USERS_RESET_NOTIFICATIONS_TYPES_ACTION = 'USERS_RESET_NOTIFICATIONS_TYPES_ACTION',
  TRANSACTION_QUEUE_ITEMS_INCOMING_LIST = 'TRANSACTION_QUEUE_ITEMS_INCOMING_LIST',
  TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST = 'TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST',
  TRANSACTION_QUEUE_ITEMS_INTERNAL_LIST = 'TRANSACTION_QUEUE_ITEMS_INTERNAL_LIST',
  TRANSACTION_QUEUE_ITEMS_EXCHANGE_LIST = 'TRANSACTION_QUEUE_ITEMS_EXCHANGE_LIST',
  TRANSACTION_QUEUE_ITEMS_NOSTRO_LIST = 'TRANSACTION_QUEUE_ITEMS_NOSTRO_LIST',
  CORPORATE_CUSTOMERS_OPEN_ACTION = 'CORPORATE_CUSTOMERS_OPEN_ACTION',
  INDIVIDUAL_CUSTOMERS_OPEN_ACTION = 'INDIVIDUAL_CUSTOMERS_OPEN_ACTION',
  NOTIFICATIONS_LIST = 'NOTIFICATIONS_LIST',
  NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_LIST = 'NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_LIST',
  NOTIFICATIONS_REPORTS_LIST = 'NOTIFICATIONS_REPORTS_LIST',
  NOTIFICATIONS_TRANSACTIONS_LIST = 'NOTIFICATIONS_TRANSACTIONS_LIST',
  NOTIFICATIONS_ISSUES_LIST = 'NOTIFICATIONS_ISSUES_LIST',
  NOTIFICATIONS_EDIT_ACTION = 'NOTIFICATIONS_EDIT_ACTION',
  NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_EDIT_ACTION = 'NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_EDIT_ACTION',
  NOTIFICATIONS_REPORTS_EDIT_ACTION = 'NOTIFICATIONS_REPORTS_EDIT_ACTION',
  NOTIFICATIONS_TRANSACTIONS_EDIT_ACTION = 'NOTIFICATIONS_TRANSACTIONS_EDIT_ACTION',
  NOTIFICATIONS_ISSUES_EDIT_ACTION = 'NOTIFICATIONS_ISSUES_EDIT_ACTION',
  NOTIFICATIONS_COMMENTS_LIST = 'NOTIFICATIONS_COMMENTS_LIST',
  NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_LIST = 'NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_LIST',
  NOTIFICATIONS_REPORTS_COMMENTS_LIST = 'NOTIFICATIONS_REPORTS_COMMENTS_LIST',
  NOTIFICATIONS_TRANSACTIONS_COMMENTS_LIST = 'NOTIFICATIONS_TRANSACTIONS_COMMENTS_LIST',
  NOTIFICATIONS_ISSUES_COMMENTS_LIST = 'NOTIFICATIONS_ISSUES_COMMENTS_LIST',
  NOTIFICATIONS_COMMENTS_CREATE_ACTION = 'NOTIFICATIONS_COMMENTS_CREATE_ACTION',
  NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_CREATE_ACTION = 'NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_CREATE_ACTION',
  NOTIFICATIONS_REPORTS_COMMENTS_CREATE_ACTION = 'NOTIFICATIONS_REPORTS_COMMENTS_CREATE_ACTION',
  NOTIFICATIONS_TRANSACTIONS_COMMENTS_CREATE_ACTION = 'NOTIFICATIONS_TRANSACTIONS_COMMENTS_CREATE_ACTION',
  NOTIFICATIONS_ISSUES_COMMENTS_CREATE_ACTION = 'NOTIFICATIONS_ISSUES_COMMENTS_CREATE_ACTION',
  NOTIFICATIONS_COMMENTS_EDIT_ACTION = 'NOTIFICATIONS_COMMENTS_EDIT_ACTION',
  NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_EDIT_ACTION = 'NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_EDIT_ACTION',
  NOTIFICATIONS_REPORTS_COMMENTS_EDIT_ACTION = 'NOTIFICATIONS_REPORTS_COMMENTS_EDIT_ACTION',
  NOTIFICATIONS_TRANSACTIONS_COMMENTS_EDIT_ACTION = 'NOTIFICATIONS_TRANSACTIONS_COMMENTS_EDIT_ACTION',
  NOTIFICATIONS_ISSUES_COMMENTS_EDIT_ACTION = 'NOTIFICATIONS_ISSUES_COMMENTS_EDIT_ACTION',
  SECTION_NOTIFICATIONS = 'SECTION_NOTIFICATIONS',
  CASP_LIST = 'CASP_LIST',
  CASP_CREATE_ACTION = 'CASP_CREATE_ACTION',
  CASP_UPDATE_ACTION = 'CASP_UPDATE_ACTION',
  CASP_EDIT_STATUS_ACTION = 'CASP_EDIT_STATUS_ACTION',
  REPORTS_REVALUATION_LIST = 'REPORTS_REVALUATION_LIST',
  REPORTS_REVALUATION_CREATE_ACTION = 'REPORTS_REVALUATION_CREATE_ACTION',
  REPORTS_REVALUATION_DELETE_ACTION = 'REPORTS_REVALUATION_DELETE_ACTION',
  LOCKS_CREATE_ACTION = 'LOCKS_CREATE_ACTION',
  LOCKS_UPDATE_ACTION = 'LOCKS_UPDATE_ACTION',
  LOCKS_LIST = 'LOCKS_LIST',
  CUSTOMERS_DEVICES_LIST = 'CUSTOMERS_DEVICES_LIST',
  CUSTOMERS_SESSIONS_DELETE_ACTION = 'CUSTOMERS_SESSIONS_DELETE_ACTION',
  EMPLOYEES_DEVICES_LIST = 'EMPLOYEES_DEVICES_LIST',
  EMPLOYEES_SESSIONS_DELETE_ACTION = 'EMPLOYEES_SESSIONS_DELETE_ACTION',
  OTHER_LIST = 'OTHER_LIST',
  SETTINGS_COUNTRIES_EDIT_RISK_SCORE_ACTION = 'SETTINGS_COUNTRIES_EDIT_RISK_SCORE_ACTION',
  SETTINGS_COUNTRIES_EDIT_ACTIVE_ACTION = 'SETTINGS_COUNTRIES_EDIT_ACTIVE_ACTION',
  OVERDRAFT_ENABLE_ALL_ACTION = 'OVERDRAFT_ENABLE_ALL_ACTION',
  OVERDRAFT_ENABLE_CUSTOMERS_ACTION = 'OVERDRAFT_ENABLE_CUSTOMERS_ACTION',
  USERS_DEVICE_SESSIONS_LIST = 'USERS_DEVICE_SESSIONS_LIST',
  CUSTOMERS_DEVICE_SESSIONS_LIST = 'CUSTOMERS_DEVICE_SESSIONS_LIST',
  EMPLOYEES_DEVICE_SESSIONS_LIST = 'EMPLOYEES_DEVICE_SESSIONS_LIST',
  TRANSACTIONS_INCOMING_COMMENTS_CREATE_ACTION = 'TRANSACTIONS_INCOMING_COMMENTS_CREATE_ACTION',
  TRANSACTIONS_INCOMING_COMMENTS_LIST = 'TRANSACTIONS_INCOMING_COMMENTS_LIST',
  TRANSACTIONS_INCOMING_COMMENTS_EDIT_ACTION = 'TRANSACTIONS_INCOMING_COMMENTS_EDIT_ACTION',
  TRANSACTIONS_INCOMING_COMMENTS_DELETE_ACTION = 'TRANSACTIONS_INCOMING_COMMENTS_DELETE_ACTION',
  TRANSACTIONS_OUTGOING_COMMENTS_CREATE_ACTION = 'TRANSACTIONS_OUTGOING_COMMENTS_CREATE_ACTION',
  TRANSACTIONS_OUTGOING_COMMENTS_LIST = 'TRANSACTIONS_OUTGOING_COMMENTS_LIST',
  TRANSACTIONS_OUTGOING_COMMENTS_EDIT_ACTION = 'TRANSACTIONS_OUTGOING_COMMENTS_EDIT_ACTION',
  TRANSACTIONS_OUTGOING_COMMENTS_DELETE_ACTION = 'TRANSACTIONS_OUTGOING_COMMENTS_DELETE_ACTION',
  TRANSACTIONS_INTERNAL_COMMENTS_CREATE_ACTION = 'TRANSACTIONS_INTERNAL_COMMENTS_CREATE_ACTION',
  TRANSACTIONS_INTERNAL_COMMENTS_LIST = 'TRANSACTIONS_INTERNAL_COMMENTS_LIST',
  TRANSACTIONS_INTERNAL_COMMENTS_EDIT_ACTION = 'TRANSACTIONS_INTERNAL_COMMENTS_EDIT_ACTION',
  TRANSACTIONS_INTERNAL_COMMENTS_DELETE_ACTION = 'TRANSACTIONS_INTERNAL_COMMENTS_DELETE_ACTION',
  TRANSACTIONS_EXCHANGE_COMMENTS_CREATE_ACTION = 'TRANSACTIONS_EXCHANGE_COMMENTS_CREATE_ACTION',
  TRANSACTIONS_EXCHANGE_COMMENTS_LIST = 'TRANSACTIONS_EXCHANGE_COMMENTS_LIST',
  TRANSACTIONS_EXCHANGE_COMMENTS_EDIT_ACTION = 'TRANSACTIONS_EXCHANGE_COMMENTS_EDIT_ACTION',
  TRANSACTIONS_EXCHANGE_COMMENTS_DELETE_ACTION = 'TRANSACTIONS_EXCHANGE_COMMENTS_DELETE_ACTION',
  TRANSACTIONS_NOSTRO_COMMENTS_CREATE_ACTION = 'TRANSACTIONS_NOSTRO_COMMENTS_CREATE_ACTION',
  TRANSACTIONS_NOSTRO_COMMENTS_LIST = 'TRANSACTIONS_NOSTRO_COMMENTS_LIST',
  TRANSACTIONS_NOSTRO_COMMENTS_EDIT_ACTION = 'TRANSACTIONS_NOSTRO_COMMENTS_EDIT_ACTION',
  TRANSACTIONS_NOSTRO_COMMENTS_DELETE_ACTION = 'TRANSACTIONS_NOSTRO_COMMENTS_DELETE_ACTION',
  CORPORATE_CUSTOMERS_COMMENTS_CREATE_ACTION = 'CORPORATE_CUSTOMERS_COMMENTS_CREATE_ACTION',
  CORPORATE_CUSTOMERS_COMMENTS_LIST = 'CORPORATE_CUSTOMERS_COMMENTS_LIST',
  CORPORATE_CUSTOMERS_COMMENTS_EDIT_ACTION = 'CORPORATE_CUSTOMERS_COMMENTS_EDIT_ACTION',
  CORPORATE_CUSTOMERS_COMMENTS_DELETE_ACTION = 'CORPORATE_CUSTOMERS_COMMENTS_DELETE_ACTION',
  INDIVIDUAL_CUSTOMERS_COMMENTS_CREATE_ACTION = 'INDIVIDUAL_CUSTOMERS_COMMENTS_CREATE_ACTION',
  INDIVIDUAL_CUSTOMERS_COMMENTS_LIST = 'INDIVIDUAL_CUSTOMERS_COMMENTS_LIST',
  INDIVIDUAL_CUSTOMERS_COMMENTS_EDIT_ACTION = 'INDIVIDUAL_CUSTOMERS_COMMENTS_EDIT_ACTION',
  INDIVIDUAL_CUSTOMERS_COMMENTS_DELETE_ACTION = 'INDIVIDUAL_CUSTOMERS_COMMENTS_DELETE_ACTION',
  PAYMENTS_ORDERS_LIST = 'PAYMENTS_ORDERS_LIST',
  PAYMENTS_ORDERS_BENEFICIARIES_LIST = 'PAYMENTS_ORDERS_BENEFICIARIES_LIST',
  PAYMENTS_ORDERS_CREATE_ACTION = 'PAYMENTS_ORDERS_CREATE_ACTION',
  PAYMENTS_ORDERS_EDIT_ACTION = 'PAYMENTS_ORDERS_EDIT_ACTION',
  PAYMENTS_ORDERS_DELETE_ACTION = 'PAYMENTS_ORDERS_DELETE_ACTION',
  PAYMENTS_ORDERS_BENEFICIARIES_CREATE_ACTION = 'PAYMENTS_ORDERS_BENEFICIARIES_CREATE_ACTION',
  PAYMENTS_ORDERS_BENEFICIARIES_EDIT_ACTION = 'PAYMENTS_ORDERS_BENEFICIARIES_EDIT_ACTION',
  PAYMENTS_ORDERS_BENEFICIARIES_DELETE_ACTION = 'PAYMENTS_ORDERS_BENEFICIARIES_DELETE_ACTION',
  ANONYMIZE_LOGS_LIST = 'ANONYMIZE_LOGS_LIST',
  TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_LIST = 'TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_LIST',
  TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_CREATE_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_CREATE_ACTION',
  TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_DELETE_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_DELETE_ACTION',
  TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_EDIT_ACTION = 'TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_EDIT_ACTION',
  WARNINGS_LIST = 'WARNINGS_LIST',
  WARNINGS_DOWNLOAD_ACTION = 'WARNINGS_DOWNLOAD_ACTION',
  PSP_INTEGRATION_LOGS_LIST = 'PSP_INTEGRATION_LOGS_LIST',
  PSP_INTEGRATION_LOGS_LIST_BY_PSP_PARTNER = 'PSP_INTEGRATION_LOGS_LIST_BY_PSP_PARTNER',
  TRANSACTIONS_RULES_LIST = 'TRANSACTIONS_RULES_LIST',
  TRANSACTIONS_RULES_CREATE_ACTION = 'TRANSACTIONS_RULES_CREATE_ACTION',
  TRANSACTIONS_RULES_EDIT_ACTION = 'TRANSACTIONS_RULES_EDIT_ACTION',
  PSP_INTEGRATION_CASPS_CHAINS_LIST = 'PSP_INTEGRATION_CASPS_CHAINS_LIST',
  PSP_INTEGRATION_CASPS_CHAINS_CREATE_ACTION = 'PSP_INTEGRATION_CASPS_CHAINS_CREATE_ACTION',
  PSP_INTEGRATION_CASPS_CHAINS_DELETE_ACTION = 'PSP_INTEGRATION_CASPS_CHAINS_DELETE_ACTION',
  REPORTS_ACCOUNTING_JOBS_LITS = 'REPORTS_ACCOUNTING_JOBS_LITS',
  REPORTS_ACCOUNTING_JOBS_CREATE_ACTION = 'REPORTS_ACCOUNTING_JOBS_CREATE_ACTION',
  REPORTS_ACCOUNTING_JOBS_RESTATEMENT_CREATE_ACTION = 'REPORTS_ACCOUNTING_JOBS_RESTATEMENT_CREATE_ACTION',
  REPORTS_ACCOUNTING_JOBS_CANCEL_ACTION = 'REPORTS_ACCOUNTING_JOBS_CANCEL_ACTION',
  REPORTS_ACCOUNTING_JOBS_EDIT_ACTION = 'REPORTS_ACCOUNTING_JOBS_EDIT_ACTION',
  BLACKLISTS_ITEMS_LIST = 'BLACKLISTS_ITEMS_LIST',
  BLACKLISTS_ITEMS_CREATE_ACTION = 'BLACKLISTS_ITEMS_CREATE_ACTION',
  BLACKLISTS_ITEMS_DELETE_ACTION = 'BLACKLISTS_ITEMS_DELETE_ACTION',
  INDIVIDUAL_CUSTOMERS_SCORE_LIST = 'INDIVIDUAL_CUSTOMERS_SCORE_LIST',
  CORPORATE_CUSTOMERS_SCORE_LIST = 'CORPORATE_CUSTOMERS_SCORE_LIST',
  INDIVIDUAL_CUSTOMERS_SCORE_CREATE_ACTION = 'INDIVIDUAL_CUSTOMERS_SCORE_CREATE_ACTION',
  CORPORATE_CUSTOMERS_SCORE_CREATE_ACTION = 'CORPORATE_CUSTOMERS_SCORE_CREATE_ACTION',
  INDIVIDUAL_CUSTOMERS_SCORE_AUTO_ON_ACTION = 'INDIVIDUAL_CUSTOMERS_SCORE_AUTO_ON_ACTION',
  CORPORATE_CUSTOMERS_SCORE_AUTO_ON_ACTION = 'CORPORATE_CUSTOMERS_SCORE_AUTO_ON_ACTION',
  INDIVIDUAL_CUSTOMERS_ASSIGN_SCORE_ACTION = 'INDIVIDUAL_CUSTOMERS_ASSIGN_SCORE_ACTION',
  CORPORATE_CUSTOMERS_ASSIGN_SCORE_ACTION = 'CORPORATE_CUSTOMERS_ASSIGN_SCORE_ACTION',
  APPLICATIONS_CUSTOMERS_SCORE_LIST = 'APPLICATIONS_CUSTOMERS_SCORE_LIST',
  APPLICATIONS_CUSTOMERS_SCORE_CREATE_ACTION = 'APPLICATIONS_CUSTOMERS_SCORE_CREATE_ACTION',
  APPLICATIONS_CUSTOMERS_SCORE_AUTO_ON_ACTION = 'APPLICATIONS_CUSTOMERS_SCORE_AUTO_ON_ACTION',
  APPLICATIONS_CUSTOMERS_ASSIGN_SCORE_ACTION = 'APPLICATIONS_CUSTOMERS_ASSIGN_SCORE_ACTION',
  IBAN_VALIDATE_ACTION = 'IBAN_VALIDATE_ACTION',
  IBAN_BIC_VALIDATE_ACTION = 'IBAN_BIC_VALIDATE_ACTION',
  IBAN_BIC_SEARCH_ACTION = 'IBAN_BIC_SEARCH_ACTION',
  PSP_INTEGRATION_FEE_SETTINGS_EDIT_ACTION = 'PSP_INTEGRATION_FEE_SETTINGS_EDIT_ACTION',
  PSP_INTEGRATION_EXTERNAL_VAULT_SETTINGS_EDIT_ACTION = 'PSP_INTEGRATION_EXTERNAL_VAULT_SETTINGS_EDIT_ACTION',
  PSP_INTEGRATION_PAYMENT_ACCOUNT_LIST = 'PSP_INTEGRATION_PAYMENT_ACCOUNT_LIST',
  PURPOSE_CODE_SETTINGS_LIST = 'PURPOSE_CODE_SETTINGS_LIST',
  PURPOSE_CODE_SETTINGS_CREATE_ACTION = 'PURPOSE_CODE_SETTINGS_CREATE_ACTION',
  PURPOSE_CODE_SETTINGS_EDIT_ACTION = 'PURPOSE_CODE_SETTINGS_EDIT_ACTION',
  PURPOSE_CODE_SETTINGS_DELETE_ACTION = 'PURPOSE_CODE_SETTINGS_DELETE_ACTION',
  CASP_ALIAS_LIST = 'CASP_ALIAS_LIST',
  CASP_ALIAS_CREATE_ACTION = 'CASP_ALIAS_CREATE_ACTION',
  CASP_ALIAS_UPDATE_ACTION = 'CASP_ALIAS_UPDATE_ACTION',
  CASP_ALIAS_DELETE_ACTION = 'CASP_ALIAS_DELETE_ACTION',
  PSP_INTEGRATION_ACCOUNT_AUTO_CREATE_CURRENCIES_EDIT_ACTION = 'PSP_INTEGRATION_ACCOUNT_AUTO_CREATE_CURRENCIES_EDIT_ACTION',
  PSP_INTEGRATION_FEE_TIER_LIST = 'PSP_INTEGRATION_FEE_TIER_LIST',
  PSP_INTEGRATION_FEE_TIER_ADD_ACTION = 'PSP_INTEGRATION_FEE_TIER_ADD_ACTION',
  PSP_INTEGRATION_FEE_TIER_EDIT_ACTION = 'PSP_INTEGRATION_FEE_TIER_EDIT_ACTION',
  PSP_INTEGRATION_FEE_TIER_DELETE_ACTION = 'PSP_INTEGRATION_FEE_TIER_DELETE_ACTION',
  EXTERNAL_ORGANIZATIONS_LIST = 'EXTERNAL_ORGANIZATIONS_LIST',
  EXTERNAL_ORGANIZATIONS_CREATE_ACTION = 'EXTERNAL_ORGANIZATIONS_CREATE_ACTION',
  EXTERNAL_ORGANIZATIONS_UPDATE_ACTION = 'EXTERNAL_ORGANIZATIONS_UPDATE_ACTION',
  EXTERNAL_ORGANIZATIONS_DELETE_ACTION = 'EXTERNAL_ORGANIZATIONS_DELETE_ACTION',
  CUSTOMERS_EXTERNAL_ORGANIZATIONS_LIST = 'CUSTOMERS_EXTERNAL_ORGANIZATIONS_LIST',
  DICTIONARIES_LIST = 'DICTIONARIES_LIST',
  DICTIONARIES_ITEMS_LIST = 'DICTIONARIES_ITEMS_LIST',
  DICTIONARIES_ITEMS_CREATE_ACTION = 'DICTIONARIES_ITEMS_CREATE_ACTION',
  DICTIONARIES_ITEMS_UPDATE_ACTION = 'DICTIONARIES_ITEMS_UPDATE_ACTION',
  DICTIONARIES_ITEMS_DELETE_ACTION = 'DICTIONARIES_ITEMS_DELETE_ACTION',
  REGULATORY_REPORT_FINTRAC_LIST = 'REGULATORY_REPORT_FINTRAC_LIST',
  REGULATORY_REPORT_FINTRAC_CREATE_ACTION = 'REGULATORY_REPORT_FINTRAC_CREATE_ACTION',
  REGULATORY_REPORT_FINTRAC_UPDATE_ACTION = 'REGULATORY_REPORT_FINTRAC_UPDATE_ACTION',
  REGULATORY_REPORT_FINTRAC_DELETE_ACTION = 'REGULATORY_REPORT_FINTRAC_DELETE_ACTION',
  SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION = 'SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION',
  PSP_INTEGRATION_EXCHANGE_TOLERANCE_EDIT_ACTION = 'PSP_INTEGRATION_EXCHANGE_TOLERANCE_EDIT_ACTION',
  PSP_INTEGRATION_PAYMENT_ACCOUNT_ADD_ACTION = 'PSP_INTEGRATION_PAYMENT_ACCOUNT_ADD_ACTION',
  PSP_INTEGRATION_PAYMENT_ACCOUNT_EDIT_ACTION = 'PSP_INTEGRATION_PAYMENT_ACCOUNT_EDIT_ACTION',
  PSP_INTEGRATION_PAYMENT_ACCOUNT_DELETE_ACTION = 'PSP_INTEGRATION_PAYMENT_ACCOUNT_DELETE_ACTION',
}

export type PermissionsAction = Partial<
  Record<PermissionEnum, { title: string; description?: string }>
>;

export type PermissionsPage = Partial<
  Record<PermissionEnum, { title: string; actions?: PermissionsAction }>
>;

export type PermissionsSection = Partial<
  Record<PermissionEnum, { title: string; pages?: PermissionsPage }>
>;

export type AllActionsSection = Partial<
  Record<PermissionEnum, PermissionsAction>
>;

export interface ChangeLog {
  id: string;
  action: { name: string; value: string };
  date: string;
  userName: string;
}

export interface CreateRoleFormValues {
  name: string;
  userIds?: string[];
  notificationTypeTemplateId?: string;
}

export interface EditRoleFormValues {
  name: string;
  notificationTypeTemplateId?: string;
  active: boolean;
}

export type CreateRoleRequest = CreateRoleFormValues;

export interface EditRoleRequest extends EditRoleFormValues {
  permissions?: PermissionEnum[];
  notificationTypeTemplateId?: string;
}

export interface RoleDetails {
  id: string;
  name: string;
  active: boolean;
  usersCount: number;
  permissions: PermissionEnum[];
  notificationTypeTemplateId?: string;
}

export interface RoleValidator {
  createRoleTemplateSchema: ValidatorsProps;
  updateRoleTemplateSchema: ValidatorsProps;
}

export interface ColumnWithConfirmTypes {
  children: React.JSX.Element[];
  onSubmit: () => void;
  onCancel: () => void;
  editIsLoading?: boolean;
  globalError?: string;
}
